// Quick re-asks for the label of just-arrived mail (App.js labels effect).
//
// A new email is on screen before the server has labelled it, so the first ask
// comes back empty. For mail that arrived within FRESH_LABEL_WINDOW_MS and is
// still unlabelled, ask again after FRESH_LABEL_RETRY_MS[n] (n = tries so far)
// — about 3 s, 8 s, 20 s, 45 s, 90 s — then leave it to the normal 30 s
// cooldown. Older unlabelled mail is never chased: it is not about to be
// labelled (index-only mailbox, or filed long ago).
export const FRESH_LABEL_WINDOW_MS = 15 * 60 * 1000;
export const FRESH_LABEL_RETRY_MS = [3_000, 5_000, 12_000, 25_000, 45_000];

/**
 * Which of the ids just asked about to ask about again, and when.
 * @param messages  the list on screen ({ id, date|receivedDateTime })
 * @param askedIds  the ids in the request that just returned
 * @param answer    the server's { id: label } answer
 * @param tries     Map id → quick retries already scheduled
 * @returns {{ ids: string[], delayMs: number } | null}
 */
export function planFreshLabelRetry(messages, askedIds, answer, tries, now = Date.now()) {
  const asked = new Set(askedIds);
  const ids = [];
  let n = Infinity;
  for (const m of messages || []) {
    if (!m?.id || !asked.has(m.id) || answer?.[m.id]) continue;
    const at = Date.parse(m.date || m.receivedDateTime || '');
    if (!Number.isFinite(at) || now - at > FRESH_LABEL_WINDOW_MS) continue;
    const done = tries.get(m.id) || 0;
    if (done >= FRESH_LABEL_RETRY_MS.length) continue;
    ids.push(m.id);
    n = Math.min(n, done);
  }
  return ids.length ? { ids, delayMs: FRESH_LABEL_RETRY_MS[n] } : null;
}
